(function () {
  var tracks = document.querySelectorAll('.image-row-carousel-track');

  tracks.forEach(function (track) {
    var isDown = false;
    var startX = 0;
    var startScrollLeft = 0;
    var lastX = 0;
    var lastTime = 0;
    var velocity = 0;
    var pointerId = null;

    function getItemStep() {
      var item = track.querySelector('.image-row-carousel-item');
      if (!item) {
        return 0;
      }

      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      return item.getBoundingClientRect().width + gap;
    }

    function snapToNearest() {
      var step = getItemStep();
      if (!step) {
        return;
      }

      var target = Math.round(track.scrollLeft / step) * step;
      var maxScroll = track.scrollWidth - track.clientWidth;
      target = Math.max(0, Math.min(target, maxScroll));

      track.scrollTo({ left: target, behavior: 'smooth' });
    }

    function onPointerDown(event) {
      if (track.scrollWidth <= track.clientWidth) {
        return;
      }

      isDown = true;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      lastX = event.clientX;
      lastTime = Date.now();
      velocity = 0;

      track.classList.add('image-row-carousel-track--dragging');
      track.style.scrollSnapType = 'none';

      if (track.setPointerCapture) {
        track.setPointerCapture(pointerId);
      }
    }

    function onPointerMove(event) {
      if (!isDown) {
        return;
      }

      event.preventDefault();

      var deltaX = event.clientX - startX;
      track.scrollLeft = startScrollLeft - deltaX;

      var now = Date.now();
      var elapsed = now - lastTime;
      if (elapsed > 0) {
        velocity = (event.clientX - lastX) / elapsed;
      }
      lastX = event.clientX;
      lastTime = now;
    }

    function onPointerUp() {
      if (!isDown) {
        return;
      }

      isDown = false;
      track.classList.remove('image-row-carousel-track--dragging');

      var momentum = velocity * -150;
      track.scrollLeft += momentum;

      track.style.scrollSnapType = '';
      requestAnimationFrame(snapToNearest);

      if (pointerId !== null && track.releasePointerCapture) {
        track.releasePointerCapture(pointerId);
      }
      pointerId = null;
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerUp);
    track.addEventListener('pointerleave', function () {
      if (isDown) {
        onPointerUp();
      }
    });

    track.addEventListener('click', function (event) {
      if (Math.abs(velocity) > 0.05) {
        event.preventDefault();
      }
    }, true);
  });
})();
